<template>
  <div
    class="d-flex mb-0 graphs-wrap pointer-events-none bars-wrap"
    :class="[ data.class, 'align-bars-' + data.alignBars, !isLeft ? 'align-self-center align-items-end' : 'align-items-start' ]"
    :style="[ { height: barsWrapHeight + 'px', width: wrapWidth }, leftPosStyle ]"
  >
    <slot :active="active" :bar-width="barWidth">

      <component
        :is="!isSmall && isLeft ? 'BarFragmentWide' : 'BarFragment'"
        class="bar-wrap position-relative"
        v-for="(bar, idx) in data.points"
        :key="idx"
        :target="bar.val[industry]"
        :active="active"
        :h="data.height"
        :w="barWidth"
        :idx="idx"
        :label="numLabel(bar, idx)"
        :percent-size="bar.fontSize"
        :style="[ { zIndex: 10 - idx }, isLeft ? { transform: barTrans( idx ) } : {} ]"
        :is-left="isLeft"
        :ind-override="indOverride"
        :bar-label="bar.barLabel"
        :bg="bg"
        @activated.once="activated = true"
      />

    </slot>
  </div>
</template>

<script>
  import GraphMixin from '@/components/report/mixins/GraphMixin'
  import ContentMixin from '@/components/report/mixins/ContentMixin'
  import BarFragment from '@/components/report/content/BarFragment'
  import BarFragmentWide from '@/components/report/content/BarFragmentWide'

  export default {
    name: 'Bar',
    mixins: [ ContentMixin, GraphMixin ],
    data () {
      return { isLeft: this.data.alignBars === 'left', numBars: this.data.points.length }
    },
    computed: {
      barWidth () {
        return this.isLeft && !this.isSmall ? 103 : !this.isSmall ? 200 : this.isLeft ? 80 : 125
      },
      wrapWidth () {
        return this.isLeft ? '100%' : (this.barWidth * 2) + 'px'
      },
      mLeft () {
        return !this.isLeft ? 0 : this.numBars === 4 ? -60 : this.numBars * -12.5
      },
      barsWrapHeight () {
        return this.isSmall ? this.data.height : this.data.deskHeight
      },
      leftPosStyle () {
        return this.isLeft ? { transform: 'translateX(' + this.mLeft + 'px)' } : { marginLeft: this.mLeft + 'px' }
      }
    },
    methods: {
      barTrans ( idx ) {
        if ( !this.isSmall && this.isLeft ) {
          return 'translateY(' + ((idx * this.barWidth) + (idx * 12)) + 'px)'
        } else {
          return 'translateY(' + ((idx - 2) * 50 - (idx * 20)) + '%) rotate(90deg)'
        }
      },
      numLabel ( bar, idx ) {
        return {
          title: bar.title,
          pos: !this.isLeft && idx === 1 ? 'top' : 'bottom',
          align: !this.isLeft && idx === 1 ? 'right' : 'left'
        }
      }
    },
    components: { BarFragment, BarFragmentWide }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .align-bars-bottom {
    .bar-wrap:first-child .percentage-wrap {
      top       : 10%;
      transform : translate(-30%, -22%);

      @include screen-md-lg-xl {
        transform : translate(-37%, -50%);
      }
    }
    .bar-wrap:nth-child(2) .percentage-wrap {
      bottom    : 0;
      left      : 50%;
      transform : translateY(15%);

      @include screen-md-lg-xl {
        transform : translate(54%, 30%);
      }
    }
  }

  .align-bars-left .bar-wrap {
    transform-origin : left bottom;
    max-height       : 80vw;
  }

  .graph-desc {
    font-size   : 1rem;
    line-height : 2.25;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Bar.vue